module.exports = __webpack_public_path__ + "static/media/MK 8  tmp.a87c5760.mp3";